(() => {
  const initialise = () => {
    document.querySelectorAll('[data-feed-step]:not([data-feed-ready])').forEach(button => {
      button.dataset.feedReady = 'true';
      button.addEventListener('click', () => {
        const feed = document.getElementById(button.getAttribute('aria-controls'));
        if (!feed) return;
        feed.scrollBy({ left: Number(button.dataset.feedStep) * (feed.firstElementChild.getBoundingClientRect().width + 16), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
    });
    document.querySelectorAll('[data-reel]:not([data-reel-ready])').forEach(card => {
      card.dataset.reelReady = 'true';
      const video = card.querySelector('video');
      const button = card.querySelector('[data-reel-play]');
      const error = card.querySelector('[role="status"]');
      const fail = () => {
        video.hidden = true;
        button.hidden = false;
        error.hidden = false;
        card.classList.remove('is-playing');
      };
      button.addEventListener('click', () => {
        document.querySelectorAll('[data-reel] video').forEach(other => { if (other !== video) other.pause(); });
        error.hidden = true;
        video.hidden = false;
        button.hidden = true;
        card.classList.add('is-playing');
        if (!video.getAttribute('src')) video.src = video.dataset.src;
        video.focus();
        video.play().catch(error => { if (error.name !== 'AbortError') fail(); });
      });
      video.addEventListener('ended', () => {
        video.hidden = true;
        button.hidden = false;
        card.classList.remove('is-playing');
        if (document.activeElement === video) button.focus({ preventScroll: true });
      });
      video.addEventListener('play', () => {
        document.querySelectorAll('[data-reel] video').forEach(other => { if (other !== video) other.pause(); });
      });
      video.addEventListener('error', fail);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (!entries[0].isIntersecting) video.pause();
          if (!card.isConnected) observer.disconnect();
        });
        observer.observe(card);
      }
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('visibilitychange', () => { if(document.hidden) document.querySelectorAll('[data-reel] video').forEach(video => video.pause()); });
})();
